import type { DeepRequired } from '../fixtures.types'

const lenderPanel: DeepRequired<Panel> = {
  __typename: 'Panel',
  default_club: 'TEST_ID',
  excluded_lenders: [],
  fee_configurations: [],
  panel: 'WHOLE_INC_DIRECT',
  preferred_clubs: [],
  asu: null,
  bridging_advice: null,
  commercial_advice: null,
  equity_release_lifetime: null,
  gi: null,
  mortgage_advice: null,
  protection: null,
  pmi: null,
  second_charge_advice: null,
}

export default lenderPanel
